export const unlockYourPotentialData = {
  title: "Unlock Your Potential with Regenesys Programmes",
  description: `At Regenesys Business School, we believe that education is more than just acquiring knowledge.
                 It’s about developing leaders who are empowered not only with academic expertise and practical skills but also with emotional intelligence, compassion, and a sense of purpose.
                 Our programmes are designed to inspire greatness and help you create lasting impact—personally and professionally.`,
  accreditationTitle: "Accredited By",
  logos: [
    { src: "/assets/qcto.webp", alt: "QCTO Accreditation" },
    { src: "/assets/che.webp", alt: "CHE Accreditation" },
  ],
};
